import React, { useState, useEffect, useCallback } from "react";
import { Header } from "../Header-Assesment/Header";
import { Card } from "./Card";
import "./Questions-Card.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TabBar } from "./Tab-bar";

// Define the order of assessment domains
const tabFlow = ["physical", "emotional", "acceptance", "relationships", "loving kindness", "intellectual"];

// Helper function to capitalize the first letter of a string
const capitalize = (s) => {
    if (!s) return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
};

export const QuestionCard = ({
    headerTitle = "",
    headerSubtitle = "",
    breadcrumbs = [],
    domain: initialDomain,  // Starting domain from props (default to "physical")
}) => {
    const normalizeDomain = (d) => (d || "physical").toLowerCase().replace(/[_-]/g, " ");
    const [activeTab, setActiveTab] = useState(normalizeDomain(initialDomain)); // Current domain tab
    const [domainProgress, setDomainProgress] = useState({}); // Progress map for each domain

    useEffect(() => {
        if (initialDomain) {
            setActiveTab(normalizeDomain(initialDomain));
        }
    }, [initialDomain]);

    // Compute completed tabs based on the current active tab's index in tabFlow
    const completedTabs = React.useMemo(() => {
        const normTab = normalizeDomain(activeTab);
        const currentIndex = tabFlow.indexOf(normTab);
        if (currentIndex > 0) {
            return tabFlow.slice(0, currentIndex).map(capitalize);
        }
        return [];
    }, [activeTab]);

    // Handler for switching tabs manually
    const handleTabChange = useCallback((tab) => {
        setActiveTab(normalizeDomain(tab));
    }, []);

    // Callback called when a section is completed — moves to the next tab if available
    const handleSectionComplete = useCallback((completedTab) => {
        const normTab = normalizeDomain(completedTab);
        const currentTabIndex = tabFlow.indexOf(normTab);
        if (currentTabIndex >= 0 && currentTabIndex < tabFlow.length - 1) {
            setActiveTab(tabFlow[currentTabIndex + 1]); // Move to next domain
        } else {
            console.log("All sections completed."); // End of flow
        }
    }, []);

    // Updates progress for a specific domain
    const handleDomainProgressUpdate = useCallback((domain, progress) => {
        const normDomain = normalizeDomain(domain);
        setDomainProgress((prev) => {
            if (prev[normDomain] === progress) return prev;
            return {
                ...prev,
                [normDomain]: progress,
            };
        });
    }, []);

    return (
        <div className="Questioncard">
            <div className="header-assessment">
                <Header title={headerTitle} subtitle={headerSubtitle} />
            </div>
            <div className="toppart">
                <div className="breadcrumb">
                    {breadcrumbs.map((crumb, i) => (
                        <React.Fragment key={i}>
                            {crumb.icon && (
                                <FontAwesomeIcon icon={crumb.icon} style={{ color: "#c1c0bd" }} />
                            )}
                            <p className={crumb.active ? "element-text3" : "element-text"}>
                                {crumb.text}
                            </p>
                            {i !== breadcrumbs.length - 1 && <p className="overline">/</p>}
                        </React.Fragment>
                    ))}
                </div>
            </div>
            <div className="assessment-que">
                <TabBar
                    activeTab={activeTab}
                    setActiveTab={handleTabChange}
                    completedTabs={completedTabs}
                    domainProgress={domainProgress}
                />
                <Card
                    domain={activeTab.toLowerCase()}
                    completedTabs={completedTabs} 
                    activeTab={activeTab}
                    onComplete={handleSectionComplete} 
                    onDomainProgressUpdate={handleDomainProgressUpdate}
                />
            </div>
        </div>
    );
};